<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useModals } from "@/composables/useModals";
import { useQuizMatchesStore } from "@/stores/storeQuizMatches";
import { useRequestsStore } from "@/stores/storeRequests";
import { useGameHistory } from "@/composables/useGameHistory";
import { trackAdriver } from "@/utils/metrika";
import BaseButtonUploadReceipt from "@/components/ui/BaseButtonUploadReceipt.vue";
import QuizSlideTimer from "@/components/quize/QuizSlideTimer.vue";

const storeQuizMatches = useQuizMatchesStore();
const storeRequests = useRequestsStore();

const { openModal } = useModals();
const { remainingTime, isPaused, initTimer, updateFromServerResponse, stopTimer } = useGameHistory();

const subtitle = computed(() => {
	return storeRequests.isAuthenticated
		? "Ваш подарок сохранён. Загрузите чек, чтобы узнать, что внутри."
		: "Ваш подарок доступен в течение 24 часов. Авторизуйтесь и загрузите чек, чтобы его получить.";
});

onMounted(async () => {
	if (storeQuizMatches.quizData) {
		updateFromServerResponse(storeQuizMatches.quizData);
		// console.log('storeQuizMatches.quizData:',storeQuizMatches.quizData);
	} else {
		await initTimer();
	}
});

onUnmounted(() => {
	storeQuizMatches.resetGame();
});
</script>
<template>
	<div class="quiz-end-game quiz-padding">
		<div class="container">
			<div class="quiz-end-game__container">
				<div class="quiz-end-game__block">
					<h2 class="quiz-end-game__title game-title">Игра «3 в ряд»!</h2>
					<div class="quiz-end-game__scope">Игра завершена, Ваш счет: <span>{{ storeQuizMatches.currentScore }}</span></div>
					<p class="quiz-end-game__subtitle">{{ subtitle }}</p>
					<div class="quiz-end-game__btns">
						<BaseButtonUploadReceipt type-btn="game_3_in_a_row_lk_2" v-if="storeRequests.isAuthenticated" class="quiz-end-game__btn">Загрузить чек</BaseButtonUploadReceipt>
						<button v-else @click="openModal('registration')" class="quiz-end-game__btn btn">Зарегистрироваться</button>
					</div>
				</div>
				<div class="quiz-end-game__box">
					<QuizSlideTimer class="--big --decor" :time="remainingTime" />
				</div>
				<div class="quiz-end-game__btns --mobile">
					<BaseButtonUploadReceipt type-btn="game_3_in_a_row_lk_2" v-if="storeRequests.isAuthenticated" class="quiz-end-game__btn">Загрузить чек</BaseButtonUploadReceipt>
					<button v-else @click="openModal('registration')" class="quiz-end-game__btn btn">Зарегистрироваться</button>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.quiz-end-game {
	&__container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 1rem;
		@media (max-width: vars.$mn) {
			flex-direction: column;
			gap: 2.4rem;
		}
	}

	&__block {
		width: fit-content;
		display: grid;
		gap: 3rem;
		justify-items: start;
		@media (max-width: vars.$mn) {
			gap: 2rem;
			justify-items: center;
		}
	}

	&__title {
		line-height: 100%;
		@media (max-width: vars.$mn) {
			text-align: center;
		}
	}

	&__scope {
		font-weight: 500;
		@media (max-width: vars.$x480) {
			font-size: 1.6rem;
			line-height: 140%;
		}
		span {
			font-weight: 700;
			color: var(--text-accent-2-100);
		}
	}

	&__subtitle {
		max-width: 62.2rem;
		@media (max-width: vars.$mn) {
			text-align: center;
		}
		@media (max-width: vars.$x480) {
			font-size: 1.6rem;
			line-height: 140%;
		}
	}
	&__btns {
		@media (max-width: vars.$mn) {
			display: none;
		}
		&.--mobile {
			display: none;
			@media (max-width: vars.$mn) {
				display: block;
			}
		}
	}
	&__btn {
	}

	&__box {
		@media (max-width: vars.$x480) {
			width: 100%;
		}
	}
}
</style>
